// Authentication helper

import axios from "axios";
import topbar from "topbar";
import { clearStorage } from "./storage";

/**
 * Checks if a user is logged in or not
 *
 * @returns {string|null}
 */
export const isAuthenticated = () => {
    return localStorage.getItem('auth_token');
};

/**
 * Authenticate a user and save the token in the storage
 *
 * @param {string} user the username
 * @param {string} pass the password
 *
 * @returns {boolean}
 */
export const authenticateUser = async (user, pass) => {
    return new Promise((resolve) => {
        axios.post(import.meta.env.VITE_API_URL + 'authenticate', {
            email: user,
            password: pass
        })
            .then((response) => {
                if (response && response?.data?.access_token && response?.data?.refresh_token) {
                    localStorage.setItem('auth_token', response.data.access_token);
                    localStorage.setItem('refresh_token', response.data.refresh_token);

                    resolve({ success: true });

                } else {
                    resolve({ success: false, error: response?.data });
                }
            })
            .catch((error) => {
                console.log(error);

                let customError = {
                    data: null,
                    response: null,
                    responseData: null,
                    status: null,
                    messages: null
                };

                if (error) {
                    customError.data = error;

                    if (error.response) {
                        customError.response = error.response;

                        if (error.response.data) {
                            customError.responseData = error.response.data;

                            if (error.response.data.errors) {
                                customError.messages = error.response.data.errors;
                            }
                        }

                        if (error.response.status) {
                            customError.status = error.response.status;
                        }
                    }
                }

                resolve({ success: false, error: customError });
            });
    });
};

/**
 * Get a new access_token using an existing refresh_token
 *
 * @returns {boolean}
 */
export const refreshToken = async () => {
    return new Promise((resolve) => {
        let getRefreshToken = localStorage.getItem('refresh_token');

        if (getRefreshToken) {
            axios.post(import.meta.env.VITE_API_URL + 'refresh-token', {
                refresh_token: getRefreshToken
            })
                .then((response) => {
                    // console.log(response);
                    if (response && response.data && response.data.access_token && response.data.refresh_token) {
                        localStorage.setItem('auth_token', response.data.access_token);
                        localStorage.setItem('refresh_token', response.data.refresh_token);

                        resolve(true);

                    } else {
                        resolve(false);
                    }
                })
                .catch((error) => {
                    // console.log(error);
                    resolve(false);
                });

        } else {
            resolve(false);
        }
    });
};

/**
 * Logout the user (delete local storage and make a request to revoke the tokens)
 */
export const logoutUser = () => {
    topbar.show();

    axios.get(import.meta.env.VITE_API_URL + 'logout', {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('auth_token')
        }
    }).then()
    .catch(() => {
        topbar.hide();
        clearStorage();
        window.location.replace(import.meta.env.VITE_SITE_URL);
    })
    .then(() => {
        topbar.hide();
        clearStorage();
        window.location.replace(import.meta.env.VITE_SITE_URL);
    });
};
